import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

import Dashboard from '../../components/Dashboard';
import { deleteEndrosment, get_endrosments } from '../../redux/modules/endrosment/action';
import AddEndrosment from './AddEndrosment';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  button: {
    margin: theme.spacing.unit,
    float: 'left'
  },
  title: {
    margin: theme.spacing.unit,
    float: 'left'
  },
  chip: {
    margin: theme.spacing.unit,
  },
});

class Endrosments extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    classes: PropTypes.object
  }


  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(get_endrosments());
  }

  delete = (id) => {
    const { dispatch } = this.props;
    dispatch(deleteEndrosment(id));
  }

  render() {
    const { classes, endrosmentList } = this.props;

    return (
      <Dashboard>
        <React.Fragment>
          <Typography className={classes.title} variant="h4">Endrosments</Typography>
          
          <Paper className={classes.root}>
            <AddEndrosment />
            {endrosmentList.map((l, idx) => {
              return (
                <Chip
                  key={idx}
                  label={l.name}
                  className={classes.chip}
                  color="primary"
                  onDelete={() => this.delete(l.id)}
                />
              )
            })}

          </Paper>
        </React.Fragment>
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    endrosmentList: state.endrosment.list
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Endrosments));